export const   fetched= 'FETCHED-INCOMPLETE-LISTINGS'
export const   error= 'ERROR-INCOMPLETE-LISTING'
export const   updated= 'UPDATED-INCOMPLETE-LISTING'
export const   remove= 'DELETE-INCOMPLETE-LISTING'
export const   reset= 'RESET-INCOMPLETE-LISTING'
export const   addIncomplete= 'ADD-INCOMPLETE-LISTING'
export const   updateIncomplete= 'UPDATE-INCOMPLETE-LISTING'
